import { IPromise, IQService } from 'angular';
import { IFontStyleModel } from '../../tn.common';
import { FontCssService } from '../font-css.service/font-css.service';

export class FontLoader {
    static $inject = ['$q', 'tn.fontCssService'];
    constructor(protected $q: IQService, protected fontCss: FontCssService) {}

    // load a font, returns the font_file_id on success.
    public get(font: IFontStyleModel, allSubsets = false): IPromise<number> {
        const font_file_id = font.font_file_id;
        const fontface = this.fontCss.addFontStyles(font, allSubsets);
        const deferred = this.$q.defer<number>();
        fontface.loaded.then(() => {
            deferred.resolve(font_file_id);
        });
        fontface.loaded.catch((error) => {
            deferred.reject(error);
        });
        return deferred.promise;
    }
}
